import { Input } from './input';
import type { InputProps } from './type';

import { FormControl, FormItem, FormMessage } from '../form';

export const FormInputTrimmed = ({
  formItemClassName,
  value,
  ...props
}: InputProps & { formItemClassName?: string }) => (
  <FormItem className={formItemClassName}>
    <FormControl>
      <Input {...props} value={`${value ?? ''}`.trim()} />
    </FormControl>
    <FormMessage />
  </FormItem>
);
